<template>
    <div class="ns-hide-sec">
        <div class="flex items-center justify-around">
            <!-- Overall Score graph -->
            <FiveKReportPieChartVue v-if="renderChart" :data="overallScore" style="position: absolute; top: -850px" />
            <!-- Critical score graph -->
            <FiveKReportPieChartVue v-if="renderChart" :data="criticalScore" style="position: absolute; top: -850px" />
        </div>
        <div class="flex items-center justify-around">
            <!-- Non Critical score graph -->
            <FiveKReportPieChartVue v-if="renderChart" :data="nonCriticalScore" style="position: absolute; top: -850px" />
            <!-- Audit score graph -->
            <FiveKReportPieChartVue v-if="renderChart" :data="auditScore" style="position: absolute; top: -850px" />
        </div>
        <!-- <a @click="processPdfDownload">Download PDF</a> -->
        <FiveKReportBarChart v-if="renderBarChart" :data="process_audit_trend_data"
            style="position: absolute; top: -850px" />
        <!-- <div  id="five-k-report" ref="pdfContent" class="ns-five-k-report-pdf">
        </div> -->
    </div>
</template>

<script>
import moment from 'moment';
import { EventBus } from '../../../eventBus';
import { mapState, mapActions } from "vuex";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import FiveKReportPieChartVue from '../graphs/FiveKReportPieChart.vue';
import bigBasketLogo from '../../../assets/images/logo/big_basket.png';
import blueTokaiLogo from '../../../assets/images/logo/bt3_2.png';
import nymbleUpLogo from '../../../assets/images/logo/NymbleUp - N.jpg';
import sign_placeholder from '../../../assets/images/sign_placeholder.png';
import starbucksLogo from '../../../assets/images/logo/sb-my.png';
import goodFlippingLogo from '../../../assets/images/logo/gfb-logo.png';
import jsPDF from 'jspdf';
import FiveKReportBarChart from '../graphs/FiveKReportBarChart.vue';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import commonUtils from '../../../utils/common.utils';
import { fiveKPdfStyles } from '../../../utils/pdfMake.utils';
export default {
    name: "FiveKReport",
    components: {
        FiveKReportPieChartVue,
        FiveKReportBarChart
    },
    props: {
        metaData: {
            type: Object,
            default: () => { }
        },
        data: {
            type: Object,
            default: () => { }
        },
        previousData: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            moment: moment,
            default_sign_placeholder: sign_placeholder,
            is_pdf_downloaded: true,
            bb_logo: bigBasketLogo,
            bt_logo: blueTokaiLogo,
            default_logo: nymbleUpLogo,
            sb_logo: starbucksLogo,
            gf_logo: goodFlippingLogo,
            overallScore: {
                name: 'Overall Score %',
                key: 'overallScore',
                data: [
                    { value: 0, name: 'Compliant' },
                    { value: 0, name: 'Non Compliant' }
                ]
            },
            formScore: {
                name: 'Form Score %',
                key: 'formScore',
                data: [
                    { value: 0, name: 'Compliant' },
                    { value: 0, name: 'Non Compliant' }
                ]
            },
            criticalScore: {
                name: 'Critical Score %',
                key: 'criticalScore',
                data: [
                    { value: 0, name: 'Compliant' },
                    { value: 0, name: 'Non Compliant' }
                ]
            },
            nonCriticalScore: {
                name: 'Non Critical Score %',
                key: 'noneCriticalScore',
                data: [
                    { value: 0, name: 'Compliant' },
                    { value: 0, name: 'Non Compliant' }
                ]
            },
            auditScore: {
                name: 'Audit Score %',
                key: 'auditScore',
                data: [
                    { value: 0, name: 'Compliant' },
                    { value: 0, name: 'Non Compliant' }
                ]
            },
            procAuditScore: [],
            renderChart: false,
            renderBarChart: false,
            process_audit_trend_data: {
                axis: [],
                labels: [],
                first_audit_data: [],
                second_audit_data: [],
                third_audit_data: []
            },
            total_current_score: 0,
            total_total_score: 0,
            total_score_percent: 0,
            is_summary_report: false,
            is_non_compliant_report: false,
        }
    },
    computed: {
        checkCompany() {
            return JSON.parse(localStorage.getItem('check_company'));
        },
        formData() {
            const formDataCopy = [...this.data.form_category_exeuctions];
            formDataCopy.sort((a, b) => {
                const serialNoA = a.form_category_info.serial_no;
                const serialNoB = b.form_category_info.serial_no;
                return serialNoA - serialNoB;
            });
            return formDataCopy;
        },
        getLogo() {
            const urlPath = document.location.origin;
            let logo_path = this.sb_logo;
            const base_url = localStorage.getItem('BASE_URL');
            console.log(urlPath, base_url, 'base_url - urlPath')
            if ((this.checkCompany && this.checkCompany.is_gf) || urlPath.includes('demo')) {
                logo_path = this.gf_logo;
            } else if ((this.checkCompany && this.checkCompany.is_bt) || urlPath.includes('bluetokai')) {
                logo_path = this.bt_logo;
            } else if((this.checkCompany && this.checkCompany.is_sb_india) || urlPath.includes('starbucksindia') ) {
                logo_path = this.sb_logo;
            }
            // console.log(logo_path, 'logo_path')
            return logo_path;
        }
    },
    mounted() {
        EventBus.$on('download5KPdf', () => {
            // console.log('event called download5KPdf')
            // this.addDownloadingReportCountAction();
            this.processPdfDownload();
        });
        EventBus.$on('loadPdfFirst', (obj) => {
            // console.log('event called loadPdfFirst')
            // this.addDownloadingReportCountAction();
            this.is_summary_report = obj.is_summary;
            this.is_non_compliant_report = obj.is_non_complaint;
            this.processPdfDownload();
        });
    },
    beforeDestroy() {
        EventBus.$off('download5KPdf');
        EventBus.$off('loadPdfFirst');
    },
    methods: {
        ...mapActions("CommonStore", [
            "addDownloadingReportCountAction",
            "removeDownloadingReportCountAction",
        ]),
        formatSeconds(seconds) {
            if (seconds === 0) return "0 sec"; // Handle zero seconds

            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;

            const parts = [];
            if (hours > 0) {
                parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
            }
            if (minutes > 0) {
                parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
            }
            parts.push(`${remainingSeconds} sec`);

            return parts.join(', ');
        },
        async processPdfDownload() {
            await this.getProcessAuditScore();
            let allQueData = [...this.formData];
            let resultQueData = [];

            // Filter only grade fails 
            if(this.is_non_compliant_report){
                allQueData = allQueData.map((e) => {
                    return {
                        ...e,
                        form_executions: e.form_executions
                            .filter((e1) => {
                                return e1.form_question_executions_data.some((e2) => {
                                    return e2.task_status_update_info.grade && e2.task_status_update_info.grade.toLowerCase() === 'fail';
                                });
                            })
                            .map((e1) => {
                                return {
                                    ...e1,
                                    form_question_executions_data: e1.form_question_executions_data.filter((e2) => {
                                        return e2.task_status_update_info.grade && e2.task_status_update_info.grade.toLowerCase() === 'fail';
                                    })
                                };
                            })
                    };
                });
                
                const allEmpty = allQueData.every(obj => obj.form_executions && obj.form_executions.length === 0);

                if(allEmpty){
                    //  Add text into pdf
                    allQueData = [];
                    allQueData = [{
                        form_category_info: {
                            name: 'Awesome! location is fully compliant.',
                        },
                        form_executions: []
                    }];
                }

                console.log(allQueData, 'allQueData')
            }

            // PDF header added here
            resultQueData.push(
                {
                    text: this.data.execution_setup_info.project_info.name,
                    fontSize: 16,
                    bold: true,
                    alignment: "center",
                    margin: [0, 0, 0, 10],
                },
                {
                    columns: [
                        {
                            image: await this.imageUrlToBase64(this.getLogo),
                            width: 70,
                            margin: [0, 2, 0, 0],
                            alignment: 'left'
                        },
                        {
                            table: {
                                widths: ['33%', '33%', '33%'], // Define column widths here
                                body: [
                                    [
                                        {
                                            text: [
                                                { text: 'Location: ', style: 'headText1' },
                                                { text: capitalizeWords(this.data.location_info.name) || '-', style: 'headText2' }
                                            ],
                                        },
                                        {
                                            text: [
                                                { text: 'Auditor: ', style: 'headText1' },
                                                { text: this.data.user_assigned_info.full_name ? capitalizeWords(this.data.user_assigned_info.full_name) : '-', style: 'headText2' }
                                            ],
                                        },
                                        {
                                            text: [
                                                { text: 'Region: ', style: 'headText1' },
                                                { text: capitalizeWords(this.metaData.region) || '-', style: 'headText2' }
                                            ],
                                        }
                                    ],
                                    // [
                                    //     {
                                    //         text: [
                                    //             { text: 'Check-in Time: ', style: 'headText1' },
                                    //             { text: this.metaData.checkin_time ? moment(this.metaData.checkin_time).format('lll') : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text: 'Check-out Time: ', style: 'headText1' },
                                    //             { text: this.metaData.checkout_time ? moment(this.metaData.checkout_time).format('lll') : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text: '-', style: 'headText1' },
                                    //             { text: '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    // ],
                                    // [
                                    //     {
                                    //         text: [
                                    //             { text: 'Check-in Location: ', style: 'headText1' },
                                    //             { text: this.metaData.checkin_location ? capitalizeWords(this.metaData.checkin_location) : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text: 'Check-out Location: ', style: 'headText1' },
                                    //             { text: this.metaData.checkout_location ? capitalizeWords(this.metaData.checkout_location) : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text: '-', style: 'headText1' },
                                    //             { text: '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    // ],
                                    // [
                                    //     {
                                    //         text: [
                                    //             { text: 'Project Start Time: ', style: 'headText1' },
                                    //             { text: this.metaData.started_at ? moment(this.metaData.started_at).format('lll') : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text: 'Project End Time: ', style: 'headText1' },
                                    //             { text: this.metaData.completed_at && this.metaData.started_at.completed_at ? this.metaData.started_at.completed_at : '-', style: 'headText2' }
                                    //         ],
                                    //     },
                                    //     {
                                    //         text: [
                                    //             { text:  this.data.auditee_info ? 'Auditee: ' : '', style: 'headText1' },
                                    //             { text: this.data.auditee_info ? ' (' + capitalizeWords(this.data.auditee_info.name) + ')' : '-', style: 'headText2' }
                                    //         ],
                                    //     }
                                    // ],
                                    [
                                        {
                                            text: [
                                                { text: this.data.execution_setup_info.show_fields.includes('score_%') ? 'Score: ' : '', style: 'headTexScore1' },
                                                { text: this.data.execution_setup_info.show_fields.includes('score_%') ? this.data.task_status_update_info.current_score + ' of ' + this.data.task_status_update_info.total_score + ' (' + this.calculatePercentage(this.data.task_status_update_info.current_score, this.data.task_status_update_info.total_score) + ' )' : '-', style: 'headTexScore2' }
                                            ],
                                        },
                                        {
                                            text: [
                                                { text: this.data.execution_setup_info.show_fields.includes('score_%') ? 'Grade: ' : '', style: 'headTexScore1' },
                                                { text: this.data.execution_setup_info.show_fields.includes('score_%') ? (this.data.task_status_update_info.grade ? this.data.task_status_update_info.grade : '-') : '-', style: this.data.task_status_update_info.grade && this.data.task_status_update_info.grade.toLowerCase() == 'fail' ? 'headTexScore_fail' : 'headTexScore_other' }
                                            ],
                                        },
                                        {
                                            text: [
                                                { text: !this.data.execution_setup_info.show_fields.includes('score_%') ? 'Completion % : ' : '', style: 'headTexScore1' },
                                                { text: !this.data.execution_setup_info.show_fields.includes('score_%') ?  calculatePercentage(this.data.task_status_update_info.completed, this.data.task_status_update_info.total) : '-', style: 'headTexScore2' }
                                            ],
                                        }
                                    ]
                                ],
                            },
                            margin: [20, 0, 0, 0],
                        },
                    ],
                },
            );

            if(this.data.execution_setup_info.show_fields.includes('score_%')){
                const lastRowHeader = [
                    {
                        text: [
                            { text: 'Score: ', style: 'headTexScore1' },
                            { text: this.data.task_status_update_info.current_score+ ' of ' + this.data.task_status_update_info.total_score + ' (' + this.calculatePercentage(this.data.task_status_update_info.current_score, this.data.task_status_update_info.total_score) + ' )', style: 'headTexScore2' }
                        ],
                    },
                    {
                        text: [
                            { text: 'Grade: ', style: 'headTexScore1' },
                            { text: this.data.task_status_update_info.grade ? this.data.task_status_update_info.grade : '-', style: this.data.task_status_update_info.grade && this.data.task_status_update_info.grade.toLowerCase() == 'fail' ? 'headTexScore_fail' : 'headTexScore_other' }
                        ],
                    }
                ];
            } else {
                const lastRowHeader = [
                    {
                        text: [
                            { text: 'Completion % : ', style: 'headTexScore1' },
                            { text: calculatePercentage(this.data.task_status_update_info.completed, this.data.task_status_update_info.total), style: 'headTexScore2' }
                        ],
                    }
                ]
            }

            // Table third
            let table3_title = {
                text: 'Project Points and Category - Summary ',
                style: 'tableTitleStyle',
            };
            let bb_table_third = {
                table: {
                    headerRows: 1,
                    widths: [ 70, '*', 65,65,65],
                    body: [
                        [
                            { text: "Category", key: 'dept_name', style: 'tableHeader' },
                            { text: "Name", key: 'process_name', style: 'tableHeader' }
                        ],
                    ],
                },
                margin: [0, 10, 0, 0]
            };

            bb_table_third.table.body[0].push(
                { text: "Total Points", key: 'total_score', style: 'tableHeader' },
                { text: "Points Earned", key: 'current_score', style: 'tableHeader' },
                { text: "Percentage", key: 'percentage', style: 'tableHeader' },
            );

            let dataRow3 = [];
            let totalForms = 0;
            let totalCompleted = 0;
            let totalScore = 0;
            let totalScorePercent = 0;
            let totalCompletedPercent = 0;
            let score_one = 0;
            let score_two = 0;

            let totalPoints = 0;
            let totalPointsEarned = 0;
            let totalPointsEarnedPercent = 0;

            let weightage_score_data = [];
            this.formData.forEach((e1, e1_index) => {
                e1.form_executions.forEach((e2, e2_index) => {
                    let singleDataRow = [];
                    bb_table_third.table.body[0].forEach((e3, e3_index) => {
                        if (e3.key === 'dept_name' && e2_index === 0) {
                            singleDataRow.push({ text: e1.form_category_info.name, rowSpan: e1.form_executions.length, style: 'dataRow' });
                        } else if (e3.key === 'dept_name') {
                            singleDataRow.push({});
                        } else if (e3.key === 'process_name') {
                            singleDataRow.push({ text: e2.form_info.name, style: 'dataRow' });
                        } else if (e3.key === 'critical_count') {
                            singleDataRow.push({ text: e2.task_status_update_info.total, style: 'dataRow' });
                            totalForms += parseFloat(e2.task_status_update_info.total);
                        } else if (e3.key === 'non_critical_count') {
                            singleDataRow.push({ text: e2.task_status_update_info.completed, style: 'dataRow' });
                            totalCompleted += parseFloat(e2.task_status_update_info.completed);
                        } else if (e3.key === 'completed%') {
                            singleDataRow.push({ text: calculatePercentage(e1.task_status_update_info.completed, e1.task_status_update_info.total), style: 'dataRow' });
                            // totalCompletedPercent += parseFloat(calculatePercentage(e1.task_status_update_info.completed, e1.task_status_update_info.total, 1));
                        } else if (e3.key === 'score') {
                            singleDataRow.push({ text: e2.task_status_update_info.current_score + ' of ' + e2.task_status_update_info.total_score, style: 'dataRow' });
                            score_one += parseFloat(e2.task_status_update_info.current_score);
                            score_two += parseFloat(e2.task_status_update_info.total_score); 
                        } else if (e3.key === 'score%') {
                            const total_count5 = calculatePercentage(e2.task_status_update_info.current_score, e2.task_status_update_info.total_score);
                            singleDataRow.push({ text: total_count5, style: 'dataRow' });
                            // totalScorePercent += parseFloat(total_count5);
                        } else if (e3.key === 'total_score') {
                            singleDataRow.push({ text: e2.task_status_update_info.total_score, style: 'dataRow' });
                            totalPoints += parseFloat(e2.task_status_update_info.total_score);
                        } else if (e3.key === 'current_score') {
                            singleDataRow.push({ text: e2.task_status_update_info.current_score, style: 'dataRow' });
                            totalPointsEarned += parseFloat(e2.task_status_update_info.current_score);
                        } else if (e3.key === 'percentage') {
                            const total_count5 = calculatePercentage(e2.task_status_update_info.current_score, e2.task_status_update_info.total_score);
                            singleDataRow.push({ text: total_count5, style: 'dataRow' });
                            // totalScorePercent += parseFloat(total_count5);
                        }
                    });
                    dataRow3.push(singleDataRow);
                });
            });

            
            totalPointsEarnedPercent = calculatePercentage(totalPointsEarned, totalPoints);

            let totalRow = [
                { text: 'Total', style: 'dataRowBold', colSpan: 2 }, {}, 
                { text: totalPoints, style: 'dataRowBold' }, 
                { text: totalPointsEarned, style: 'dataRowBold' }, 
                { text: totalPointsEarnedPercent, style: 'dataRowBold' }
            ];

            // procAuditScore
            const insertIndex = dataRow3.findIndex(item => item[0].text === 'BB Engagement Model');

            if (insertIndex !== -1) {
                dataRow3.splice(insertIndex, 0, this.procAuditScore);
            }

            function calculatePercentage(currentScore, totalScore, isSymbol, isOverall = false) {
                const percentage = ((currentScore / totalScore) * 100).toFixed(0);
                if (isSymbol) {
                    return isNaN(percentage) ? 0 : `${percentage}`;
                } else {
                    return isNaN(percentage) ? '0%' : `${percentage}%`;
                }
            }

            function capitalizeWords(sentence) {
                if (!sentence || typeof sentence !== 'string') {
                    return '-';
                }

                return sentence.replace(/\b\w/g, char => char.toUpperCase());
            }

            if (dataRow3.length) {
                dataRow3.map((d) => {
                    d = d.map((r) => {
                        r.text = r.text === 'NaN' ? '0' : r.text;
                        return r;
                    });
                    bb_table_third.table.body.push(d)
                });
            }

            // Total of third table
            bb_table_third.table.body.push(totalRow);
            // console.log(bb_table_third, 'bb_table_third')
            

            // Add  Process Audit Score Trend
            let table4_title = {
                text: 'Process Audit Score Trend',
                style: 'tableTitleStyle',
            };
            let bb_table_fourth = {
                table: {
                    headerRows: 1,
                    body: [

                    ],
                },
                margin: [0, 20, 0, 0]
            };

            let headerRow = [];
            let tableRow = [];
            if(this.previousData.length) {
                // Add audit header
                headerRow.push({ text: 'Audits', key: 'audit', style: 'tableHeader' });
                this.previousData[0].project_execution.form_category_exeuctions.forEach((e1, e1_index) => {
                    headerRow.push({ text: e1.form_category_info.name, key: e1.form_category_info.name, style: 'tableHeader' });
                });
            }

            let tempArr = [];

            function getOrdinalSuffix(number) {
                const suffixes = ["th", "st", "nd", "rd"];
                const lastDigit = number % 10;
                const suffix = lastDigit <= 3 && number !== 11 && number !== 12 && number !== 13 ? suffixes[lastDigit] : suffixes[0];
                return number + suffix;
            }

            for (let key in this.previousData) {
                if (this.previousData.hasOwnProperty(key) && this.previousData[key].project_execution.form_category_exeuctions) {
                    let temp = [];
                    // Dynamically generate the text based on the index
                    let auditText = getOrdinalSuffix(parseInt(key) + 1) + ' Project - ' + moment(this.previousData[key].project_execution.start_date, 'YYYY-MM-DD').format('MMMM YY');
                    temp.push({ text: auditText, key: 'audit_serial', style: 'dataRow' });

                    this.previousData[key].project_execution.form_category_exeuctions.forEach((e1, e1_index) => {
                        let criticalScorePercentage = calculatePercentage(e1.task_status_update_info.critical_current_score, e1.task_status_update_info.critical_total_score, 1);
                        let nonCriticalScorePercentage = calculatePercentage(e1.task_status_update_info.non_critical_current_score, e1.task_status_update_info.non_critical_total_score, 1);
                        let calcData = parseFloat(criticalScorePercentage) * 60 / 100 + parseFloat(nonCriticalScorePercentage) * 40 / 100;
                        temp.push({ text: Math.floor(Math.random() * 95) + '%', key: e1.form_category_info.name, style: 'dataRow' });
                    });
                    tempArr.push(temp);
                }
            }
            // take only first three records from tempArr
            tempArr = tempArr.slice(0, 3);
            // Add dummy values 
            tempArr.map((e) => {
                if (e[0].text.includes("3rd Project")) {
                    e.forEach((e1, i) => {
                        if (e1.key !== "audit_serial") {
                            // map weightage_score_data values index wise
                            e1.text = weightage_score_data[i - 1] ? (weightage_score_data[i - 1] + '%') : '0%';
                        }
                    });
                }
            });
            if(tempArr.length){
                tempArr[0].map((e) => {
                    // console.log(e, 'check')
                    if (e.key !== "audit_serial") {
                        this.process_audit_trend_data.labels.push(e.key);
                    }
                });
                // pass all audits values
                // this.process_audit_trend_data.first_audit_data = tempArr[0].slice(1, tempArr[0].length);
                // this.process_audit_trend_data.second_audit_data = tempArr[1].slice(1, tempArr[1].length);
                // this.process_audit_trend_data.third_audit_data = tempArr[2].slice(1, tempArr[2].length);
            }
            // now remove all data percent symbol and make them int
            this.process_audit_trend_data.first_audit_data = this.process_audit_trend_data.first_audit_data.map((e) => {
                return parseInt(e.text.replace('%', ''));
            });
            this.process_audit_trend_data.second_audit_data = this.process_audit_trend_data.second_audit_data.map((e) => {
                return parseInt(e.text.replace('%', ''));
            });
            this.process_audit_trend_data.third_audit_data = this.process_audit_trend_data.third_audit_data.map((e) => {
                return parseInt(e.text.replace('%', ''));
            });

            this.process_audit_trend_data.axis = ['1st Audit', '2nd Audit', '3rd Audit'];
            this.renderBarChart = true;
            function generateNumberFromString(str) {
                let numericValue = 0;
                for (let i = 0; i < str.length; i++) {
                    numericValue += str.charCodeAt(i);
                }
                return numericValue;
            }
            // Add dummy values
            tempArr.unshift(headerRow);
            bb_table_fourth.table.body = tempArr;

            let allQueDataArr = [];
            // All Que data for all client
            for (const [elm_index,elm] of allQueData.entries()) {
                if(this.is_summary_report) {
                    allQueDataArr.push({
                        text: elm.form_category_info.name + ' - Non Compliant',
                        style: 'categoryStyle'
                    });
                } else {
                    allQueDataArr.push({
                        text: elm.form_category_info.name,
                        style: 'categoryStyle',
                        // pageBreak: 'before'
                    });
                }
                for (const [elm2_index, elm2] of elm.form_executions.entries()) {
                    allQueDataArr.push(
                        {
                            text: [
                                { text: `${elm2_index + 1}) ` + elm2.form_info.name, style: "formTitleStyle" }, "   ",
                                { text: `( Points Achieved - ${elm2.task_status_update_info.current_score} of ${elm2.task_status_update_info.total_score} )`, style: "pointsAchStyle" }
                            ],
                            alignment: "left",
                            margin: [0, 20, 0, 15]
                        }
                    );

                    // All que loop started here
                    for (const [elm3_index, elm3] of elm2.form_question_executions_data.entries()) {
                        const totalPoints = elm3.task_status_update_info.total_score === 0
                        ?  {
                                columns: [
                                    {
                                        text: `${elm2_index + 1}_${elm3_index + 1}) ${elm3.form_question_info.name}`,
                                        style: 'queStyle',
                                        width: '90%', // Set the width to 'auto' to fit the content
                                    }
                                ],
                           } // Empty array if total score is 0 of 0
                        : {
                            columns: [
                            {
                                text: `${elm2_index  + 1}_${elm3_index  + 1}) ${elm3.form_question_info.name}`,
                                style: 'queStyle',
                                width: '90%', // Set the width to 'auto' to fit the content
                            },
                            {
                                stack: [
                                {
                                    text: 'Total Points',
                                    style: 'queContentStyle1'
                                },
                                {
                                    text: `${elm3.task_status_update_info.current_score} of ${elm3.task_status_update_info.total_score}`,
                                    style: elm3.task_status_update_info.grade == 'fail' ? 'queContentStyleRed' : 'queContentStyle'
                                },
                                ],
                                margin: [0, 0, 0, 0], // Adjust the margin values
                                width: '10%', // Set the fixed width for the second column
                            },
                            ],
                        };
                        let questionColumns = {
                            stack: [
                                {
                                    canvas: [
                                        {
                                            type: 'line',
                                            x1: 0,
                                            y1: 0,
                                            x2: 520, // Adjust the length of the line as needed
                                            y2: 0,
                                            lineWidth: 1, // Adjust the line width
                                            lineColor: 'black' // Adjust the line color
                                        }
                                    ],
                                    margin: [0, 5, 0, 5] // Add margin for space between line and text
                                }
                            ],
                        };

                        if(this.data.execution_setup_info.show_fields.includes('score_%')){
                        }
                        questionColumns.stack.push(totalPoints)
                        const isRetestValue = elm3.repeat_number_input && (elm3.form_question_info.input_type_info.name.toLowerCase() === "temperature" || elm3.form_question_info.input_type_info.name.toLowerCase() === "tpm");
                        const isTempValue = (elm3.form_question_info.input_type_info.name.toLowerCase() === "temperature" || elm3.form_question_info.input_type_info.name.toLowerCase() === "tpm");
                        const isTimerValue = (elm3.form_question_info.input_type_info.name.toLowerCase() === "timer");
                        const minMaxCondition = isTempValue && elm3.number_input >= elm3.form_question_info.minimum_value && elm3.number_input <= elm3.form_question_info.maximum_value;
                        const minMaxCondition2 = elm3.repeat_number_input >= elm3.form_question_info.minimum_value && elm3.repeat_number_input < elm3.form_question_info.maximum_value;
                        // if(isTempValue) {
                        //     console.log(minMaxCondition, elm3.form_question_info.minimum_value ,elm3.number_input, elm3.form_question_info.maximum_value, 'isRetestValue')
                        // }
                        console.log(isTimerValue, 'isTimerValue');
                        let observationsColumn = {};
                        if(isTimerValue) {
                            observationsColumn = {
                                columns: [
                                    {
                                        stack: [
                                            {
                                                text: 'Observations / Actual',
                                                style: 'queContentStyle1'
                                            },
                                        ],
                                        margin: [0, 0, 0, 0], // Adjust the margin values to minimize the gap
                                        width: 'auto', // Set the width to 'auto' to fit the content
                                    },
                                ],
                                alignment: 'left', // Adjust alignment as needed
                                margin: [0, 0, 0, 5],
                            };
                            let timerValues = this.checkObservationsData(elm3, elm3.task_status_update_info, elm3.form_question_info);
                            if(timerValues.length){
                                // Sort by serial no
                                timerValues = timerValues.sort((a,b)=> a.serial_no - b.serial_no)
                            }
                            timerValues.forEach((t)=>{
                                observationsColumn.columns[0].stack.push({
                                    text: 'Timer ' + (t.serial_no + 1) + ' : ' + this.formatSeconds(t.seconds),
                                    style: 'queContentStyle'
                                })
                            })
                        } else {
                            observationsColumn = {
                                columns: [
                                    {
                                        stack: [
                                            {
                                                text: 'Observations / Actual',
                                                style: 'queContentStyle1'
                                            },
                                            {
                                                text: (isTempValue ? 'Test Value: ' : '') + this.checkObservationsData(elm3, elm3.task_status_update_info, elm3.form_question_info),
                                                style: !minMaxCondition && elm3.number_input != null ? 'queContentStyleRed' : elm3.task_status_update_info.grade && elm3.task_status_update_info.grade.toLowerCase() == 'fail' ? 'queContentStyleRed' : 'queContentStyle'
                                            },
                                            isRetestValue ? {
                                                text: 'Retest Value: ' + this.checkObservationsData(elm3, elm3.task_status_update_info, elm3.form_question_info, true),
                                                style: !minMaxCondition2 ? 'queContentStyleRed' : elm3.task_status_update_info.grade && elm3.task_status_update_info.grade.toLowerCase() == 'fail' ? 'queContentStyleRed' : 'queContentStyle'
                                            } : '',
                                        ],
                                        margin: [0, 0, 0, 0], // Adjust the margin values to minimize the gap
                                        width: 'auto', // Set the width to 'auto' to fit the content
                                    },
                                ],
                                alignment: 'left', // Adjust alignment as needed
                                margin: [0, 0, 0, 5],
                            };
                        }

                        const commentsColumn = {
                            stack: [
                                {
                                    text: 'Comments',
                                    style: 'queContentStyle1'
                                },
                                {
                                    text: elm3.comment ? elm3.comment : '-',
                                    style: 'queContentStyle'
                                },
                            ],
                        };

                        let attachmentsColumn = {};

                        if (elm3.form_question_execution_attachments.length) {
                            attachmentsColumn = {
                                stack: await this.getAttachmentsWithCol(elm3.form_question_execution_attachments),
                                margin: [0, 5, 0, 15],
                            };
                        } else {
                            attachmentsColumn = {
                                stack: [
                                    {
                                        text: 'Attachments',
                                        style: 'queContentStyle1'
                                    },
                                    {
                                        text: '-',
                                        style: 'queContentStyle'
                                    },
                                ],
                            };
                        }

                        allQueDataArr.push(questionColumns, observationsColumn);
                        if(elm3.comment) {
                            allQueDataArr.push(commentsColumn)
                        }
                        if(elm3.form_question_execution_attachments.length) {
                            allQueDataArr.push(attachmentsColumn)
                        }

                        if (elm3.form_question_info.recommendation && elm3.task_status_update_info.current_score < 5 && elm3.task_status_update_info.status === 'completed' && !elm3.marked_as_na) {
                            allQueDataArr.push({
                                stack: [
                                    {
                                        text: 'Recommendations',
                                        style: 'queContentStyle1',
                                    },
                                    {
                                        text: elm3.form_question_info.recommendation,
                                        style: 'queContentStyle'
                                    },
                                ],
                                margin: [0, 5, 0, 15],
                            });
                        }
                    }

                }
            }
            
            // Add graph
            let overallGraph = this.generateGraphBase64('overallScore').imageBase64;
            var rowOne = {
                stack: [
                    {
                        columns: [
                            {
                                width: '*', // Column takes the full width
                                alignment: 'center', // Center-align content within the column
                                image: overallGraph, // Path to your first image
                                width: 250, // Adjust the width as needed
                            }
                        ],
                    },
                ],
                margin: [10, 20],
            };

            // Add graph
            let procAuditGraph = this.generateGraphBase64('ns-bar-chart', true).imageBase64;
            
            // Add this image into the pdf
            let procGraphD = {
                image: procAuditGraph, // Path to your first image
                width: 650, // Adjust the width as needed
                alignment: 'center', // Center-align the first image
                margin: [0, 20, 0, 0]
            };
            
            console.log(allQueDataArr, 'allQueDataArr')
            // allQueDataArr.map((e) => {
            //     resultQueData.push(e);
            // });
             // Added table third
            if(this.is_summary_report && this.data.execution_setup_info.show_fields.includes('score_%')){
                resultQueData.push(table3_title, bb_table_third);
            } else if(this.is_non_compliant_report){
                allQueDataArr.map((e) => {
                    resultQueData.push(e);
                });
            } else {
                this.data.execution_setup_info.show_fields.includes('score_%') ? resultQueData.push(table3_title, bb_table_third) : '';
                allQueDataArr.map((e) => {
                    resultQueData.push(e);
                });
            }
            

            // Add pdf footer with Auditor and Auditee signature
            const auditor_sign_img = this.data.auditor_sign_file_path ? await this.imageUrlToBase64(
                    'https://nymbleup-tasks-attachments.s3.amazonaws.com/' + this.data.auditor_sign_file_path
                ) : await this.imageUrlToBase64(this.default_sign_placeholder);
                const auditee_sign_img = this.data.auditee_sign_file_path ? await this.imageUrlToBase64(
                    'https://nymbleup-tasks-attachments.s3.amazonaws.com/' + this.data.auditee_sign_file_path
                ) : await this.imageUrlToBase64(this.default_sign_placeholder);
                // Add pdf footer with Auditor and Auditee signature
                let auditee_pdf = {
                    alignment: 'left',
                    stack: [
                        {
                            text: 'Auditee',
                            style: 'footerText',
                            alignment: 'left',
                            margin: [0, 0, 0, 0],
                        },
                        {
                            text: this.data.auditor_info && this.data.auditor_info.full_name ? this.data.auditor_info.full_name : '-',
                            style: 'footerText',
                            alignment: 'left',
                            margin: [0, 0, 0, 0],
                        },
                        {
                            image: auditee_sign_img,
                            style: 'footerText',
                            alignment: 'left',
                            width: 170,
                            height: 95,
                            margin: [0, 0, 0, 0],
                        }
                    ]
                };
                let auditor_pdf = {
                    alignment: 'right',
                    stack: [
                        {
                            text: 'Auditor',
                            style: 'footerText',
                            alignment: 'center',
                            margin: [0, 0, 0, 0],
                        },
                        {
                            text: this.data.user_assigned_info.full_name || '-',
                            style: 'footerText',
                            alignment: 'center',
                            margin: [0, 0, 0, 0],
                        },
                        {
                            image: auditor_sign_img,
                            style: 'footerText',
                            alignment: 'center',
                            width: 170,
                            height: 95,
                            margin: [0, 0, 0, 0],
                        }
                    ]
                };
                let pdf_footer = {  
                    columns: [],
                    margin: [0, 20, 0, 0],
                };

                if(this.data.auditor_sign_file_path) {
                    pdf_footer.columns.push(auditor_pdf);
                }
                if(this.data.auditee_sign_file_path) {
                    pdf_footer.columns.push(auditee_pdf);
                }
                if(this.data.auditor_sign_file_path || this.data.auditee_sign_file_path){
                    resultQueData.push(pdf_footer);
                }                    

            const documentDefinition = {
                content: resultQueData,
                styles: fiveKPdfStyles,
                pageOrientation: "portrait",
                pageSize: "A4",
                pageMargins: [40, 15, 40, 15],
            };

            this.removeDownloadingReportCountAction();
            if (this.renderChart) {
                const pdfDoc = pdfMake.createPdf(documentDefinition);
                let file_name = this.data.location_info.name.charAt(0).toUpperCase() + 
                this.data.location_info.name.slice(1).replace(/\s+/g, '-') + '_' + 
                this.data.execution_setup_info.project_info.name.replace(/\s+/g, '-') + '_' + 
                this.data.start_date + (this.is_summary_report ? '_Summary-Report' : this.is_non_compliant_report ? '_Non-Complaint-Report' : '_Full-Report') + '.pdf';
                pdfDoc.download(file_name);
                // pdfDoc.open();
                this.$nextTick(() => {
                    setTimeout(() => {
                        EventBus.$emit('pdf-downloaded');
                    }, 500);
                });
            }
        },
        async getProcessAuditScore() {
            let form_data_clone = [...this.formData];

            let critical_current_score = 0;
            let critical_total_score = 0;
            let non_critical_current_score = 0;
            let non_critical_total_score = 0;
            let current_score = 0;
            let total_score = 0;
            let overall_current_score = 0;
            let overall_total_score = 0;
            let total_critical_current_score = 0;
            let total_critical_total_score = 0;
            let total_non_critical_current_score = 0;
            let total_non_critical_total_score = 0;
            let total_audit_score = 0;

            form_data_clone.forEach((e1, e1_index) => {
                // console.log(e1, 'e1')
                if (e1.form_category_info.name === 'BB Engagement Model') {
                    return;
                }
                overall_current_score = e1.task_status_update_info.current_score += e1.task_status_update_info.current_score;
                overall_total_score = e1.task_status_update_info.total_score += e1.task_status_update_info.total_score;
                total_critical_current_score = e1.task_status_update_info.critical_current_score += e1.task_status_update_info.critical_current_score;
                total_critical_total_score = e1.task_status_update_info.critical_total_score += e1.task_status_update_info.critical_total_score;
                total_non_critical_current_score = e1.task_status_update_info.non_critical_current_score += e1.task_status_update_info.non_critical_current_score;
                total_non_critical_total_score = e1.task_status_update_info.non_critical_total_score += e1.task_status_update_info.non_critical_total_score;
                e1.form_executions.forEach((e2, e2_index) => {
                    critical_current_score += e2.task_status_update_info.critical_current_score;
                    critical_total_score += e2.task_status_update_info.critical_total_score;
                    non_critical_current_score += e2.task_status_update_info.non_critical_current_score;
                    non_critical_total_score += e2.task_status_update_info.non_critical_total_score;
                    current_score += e2.task_status_update_info.current_score;
                    total_score += e2.task_status_update_info.total_score;
                });
            });

            total_audit_score =
                calculatePercentage(total_critical_current_score, total_critical_total_score, 1) * (60 / 100) +
                calculatePercentage(total_non_critical_current_score, total_non_critical_total_score, 1) * (40 / 100);

            const score_percent = calculatePercentage(current_score, total_score);

            let procAuditScore = [
                {
                    text: 'Process Audit Score Total',
                    style: 'boldDataRow',
                    colSpan: 2
                },
                {},
                { text: current_score + ' of ' + total_score, style: 'boldDataRow' },
                { text: calculatePercentage(critical_current_score, critical_total_score), style: 'boldDataRow' },
                { text: calculatePercentage(non_critical_current_score, non_critical_total_score), style: 'boldDataRow' },
                { text: score_percent, style: 'boldDataRow' },
                { text: total_audit_score.toFixed(0) + ' %', style: 'boldDataRow' },
            ];
            
            this.procAuditScore = procAuditScore;
            this.renderChart = true;
            // All Chart data added
            this.overallScore.data[0].value = parseFloat(calculatePercentage(overall_current_score, overall_total_score, 1));
            this.overallScore.data[1].value = 100 - calculatePercentage(overall_current_score, overall_total_score, 1);
            this.criticalScore.data[0].value = parseFloat(calculatePercentage(total_critical_current_score, total_critical_total_score, 1));
            this.criticalScore.data[1].value = 100 - calculatePercentage(total_critical_current_score, total_critical_total_score, 1);
            this.nonCriticalScore.data[0].value = parseFloat(calculatePercentage(total_non_critical_current_score, total_non_critical_total_score, 1));
            this.nonCriticalScore.data[1].value = 100 - calculatePercentage(total_non_critical_current_score, total_non_critical_total_score, 1);
            this.auditScore.data[0].value = parseFloat(total_audit_score.toFixed(0));
            this.auditScore.data[1].value = (100 - total_audit_score.toFixed(0)).toFixed(0);

            // Function to calculate percentage
            function calculatePercentage(currentScore, totalScore, isSymbol) {
                const percentage = ((currentScore / totalScore) * 100).toFixed(0);
                if (isSymbol) {
                    return isNaN(percentage) ? 0 : `${percentage}`;
                } else {
                    return isNaN(percentage) ? '0 %' : `${percentage} %`;
                }
            }
        },
        calculatePercentage(currentScore, totalScore, isSymbol) {
            const percentage = ((currentScore / totalScore) * 100).toFixed(0);
            if (isSymbol) {
                return isNaN(percentage) ? 0 : `${percentage}`;
            } else {
                return isNaN(percentage) ? '0 %' : `${percentage} %`;
            }
        },
        generateGraphBase64(graphId, is_child) {
            let imageBase64 = '';
            let pieChart = '';
            let chartOne = '';
            // console.log(graphId,  document.getElementById(graphId), ' document.getElementById(graphId)');
            // If is there any id is null then call again
            if(!document.getElementById(graphId)){
                this.processPdfDownload();
                return;
            }
            if (is_child) {
                chartOne = document.getElementById(graphId).children[0];
                let parentElement = document.getElementById(graphId);
                //   // Get the first child element of the parent
                chartOne = parentElement.firstElementChild.firstElementChild;
            } else {
                chartOne = document.getElementById(graphId);
            }
            // console.log(chartOne, 'chartOne');
            // Ensure that chartOne is a valid HTMLCanvasElement
            if (chartOne instanceof HTMLCanvasElement) {
                // Convert the canvas to Base64 image
                imageBase64 = chartOne.toDataURL("image/png");
                pieChart = {
                    image: imageBase64,
                    width: 350,
                    alignment: 'left',
                    margin: [0, 20, 0, 0]
                };
                // console.log(imageBase64);
            } else {
                console.error("chartOne is not a valid HTMLCanvasElement.");
            }
            return { pieChart, imageBase64 };
        },
        async getAttachmentsWithCol(arr) {
            let result = [{ text: 'Attachments', style: 'queContentStyle1', margin: [0, 0, 0, 10] }];

            if (arr.length) {
                for (let i = 0; i < arr.length; i += 2) {
                    try {
                        const base64Image1 = await this.imageUrlToBase64(
                            'https://nymbleup-tasks-attachments.s3.amazonaws.com/' + arr[i].file_path
                        );

                        let group = {
                            columns: [
                                {
                                    image: base64Image1,
                                    width: 250,
                                    height: 315,
                                    alignment: 'center',
                                    margin: [0, 0, 15, 15],
                                },
                            ],
                            margin: [20, 0],
                        };

                        if (i + 1 < arr.length) {
                            const base64Image2 = await this.imageUrlToBase64(
                                'https://nymbleup-tasks-attachments.s3.amazonaws.com/' + arr[i + 1].file_path
                            );

                            group.columns.push({
                                image: base64Image2,
                                width: 250,
                                height: 315,
                                alignment: 'center',
                                margin: [15, 0, 0, 15],
                            });
                        }

                        result.push(group);
                    } catch (error) {
                        console.error('Error processing image:', error);
                        return (result = [
                            { text: 'Attachments', style: 'queContentStyle1' },
                            { text: '-', style: 'queContentStyle' },
                        ]);
                    }
                }
            }

            return result;
        },
        checkObservationsData(elm, task_status_update_info, form_question_info, isRetest) {
            function getOptName(id){
                return form_question_info.input_options_list.find((e)=> e.id === id) ? form_question_info.input_options_list.find((e)=> e.id === id).name : '-'
            }
            let print = '';
            // console.log(task_status_update_info, form_question_info, 'task_status_update_info');
            if (elm.marked_as_na) {
                print = 'NA'
            } else {
                if (form_question_info.input_type_info.input_data_type === "number") {
                    print = (!elm.number_input || elm.number_input == 'null') ? '-' : `${isRetest ? elm.repeat_number_input : elm.number_input} ${(form_question_info.input_type_info.name && form_question_info.input_type_info.name.toLowerCase() == "temperature" || form_question_info.input_type_info.name.toLowerCase() === "tpm") ? '°C' : ''}`;
                } else if (form_question_info.input_type_info.input_data_type === "boolean") {
                    print = elm.boolean_input === null ? '-' : elm.boolean_input ? 'Yes' : 'No'
                } else if (form_question_info.input_type_info.input_data_type === "string") {
                    print = elm.text_input ? elm.text_input : '-'
                } else if (form_question_info.input_type_info.input_data_type === "single_input_option") {
                    print = elm.input_option ? (form_question_info.input_options_list.find((e)=> e.id === elm.input_option) ? form_question_info.input_options_list.find((e)=> e.id === elm.input_option).name : '-') : '-'
                } else if (form_question_info.input_type_info.input_data_type === "multiple_input_options") {
                    print = elm.multiple_input_options.length ? this.getMultiInputPrint(form_question_info.input_options_list, elm.multiple_input_options) : '-'
                } else if (form_question_info.input_type_info.input_data_type === "number" && (form_question_info.input_type_info.name && form_question_info.input_type_info.name.toLowerCase() == "temperature" || form_question_info.input_type_info.name.toLowerCase() === "tpm")) {
                    print = elm.number_input == 'null' ? '-' : isRetest ? elm.repeat_number_input : elm.number_input + '°C';
                } else if (form_question_info.input_type_info.input_data_type === "timer") {
                    print = elm.timer_input_data.length ? elm.timer_input_data : '-'
                } else if (form_question_info.input_type_info.input_data_type === "date") {
                    print = elm.date_input ? elm.date_input : '-'
                } else if (form_question_info.input_type_info.input_data_type === "datetime") {
                    print = elm.datetime_input ? elm.datetime_input : '-'
                } else if (form_question_info.input_type_info.input_data_type === "time") {
                    print = elm.time_input   ? elm.time_input  : '-'
                } 
            }
            return print;
        },
        getMultiInputPrint(input_options_list, input_option) {
            let print = '';
            input_option.forEach((id, index) => {
                const data = input_options_list.find(e => e.id === id);
                if (data) {
                    print += data.name;
                    // Check if it's not the last element in the array and add a comma
                    if (index < input_option.length - 1) {
                        print += ', ';
                    }
                }
            });
            return print;
        },
        async imageUrlToBase64(imageUrl) {
            // console.log('Converting image URL to base64:', imageUrl)
            try {
                const response = await fetch(imageUrl);
                const blob = await response.blob();
                const base64Data = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
                return base64Data;
            } catch (error) {
                // console.error('Error converting image URL to base64:', error);
                return null;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>